import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {CacheConstants} from '../../../shared/cache-constants';
import {TvshopConstants} from '../../../shared/tvshop-constants';
import {ResourceService} from '../../../services/resource/resource.service';
import {PincodeService} from '../../../services/pincode/pincode-service';
import {OcapiService} from '../../../services/ocapi/ocapi.service';
import {PageNames} from '../../../shared/page-names.enum';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {KeyDirections} from '../../../shared/key-directions.enum';
import {BaseActions} from '../../../shared/base-actions';
import {ModalConfig} from '../../../model/modal-config';
import {takeUntil} from 'rxjs/operators';
import {CacheService} from '@ngx-cache/core';
import {Order} from '../../../model/order';
import {Error} from '../../../model/error';
import {AnalyticsService} from '../../../services/analytics/analytics.service';
import {OmapiIdConstants} from '../../../shared/omapi-id-constants';
import {OmapiIdsUtils} from '../../../shared/utils/omapi-ids/omapi-ids-utils';
import {UserTypeConstants} from '../../../shared/user-type-constants';
import {OcapiSynchronousService} from '../../../services/ocapi/ocapi.synchronous.service';
import {OcapiAsynchronousService} from '../../../services/ocapi/ocapi.asynchronous.service';
import {TvShopStateService} from '../../../services/state/tv-shop-state.service';


@Component({
  selector: 'app-input-pincode-modal',
  templateUrl: './input-pincode-modal.component.html',
  styleUrls: ['./input-pincode-modal.component.less']
})
export class ModalComponent extends BaseActions implements AfterViewInit {
  @Input() config: ModalConfig;

  @Input() order: Order;
  @Input() titleKey: string;
  @Input() pincodeDescriptionKey: string;
  @Input() pincodeIncorrectKey: string;
  @Input() pincodeRemainingTimeKey: string;
  @Input() infoKey: string;
  @Input() watchConditionsButtonText: string;
  pincode = '';

  pincodeIncorrect = false;
  timeOut = false;
  showHint = false;

  @Output()
  emitOpenConditions = new EventEmitter<Object>();

  @Output()
  emitOrderSucceeded = new EventEmitter<Object>();

  @Output()
  emitOrderFailed = new EventEmitter<Object>();
  @Output()
  emitOrderTimeOut = new EventEmitter<Object>();
  @Output()
  emitOnBack = new EventEmitter<Object>();
  componentName = PageNames.PINCODE_MODAL;

  numberOfTimeLeft: number;
  suspensionExpiration: number;
  suspension: boolean;
  activationPending = false;
  logoUrl: string;

  constructor(protected navigationService: NavigationService,
              private changeDetector: ChangeDetectorRef,
              @Inject('PincodeService') private pincodeService: PincodeService,
              private ocapiService: OcapiService,
              private ocapiSynchronousService: OcapiSynchronousService,
              private ocapiAsynchronousService: OcapiAsynchronousService,
              private cacheService: CacheService,
              private resourceService: ResourceService,
              private stateService: TvShopStateService,
              private analyticsService: AnalyticsService) {
    super();
  }


  ngAfterViewInit(): void {
    this.logoUrl = this.resourceService.getLogoUrl(this.order.packOmapiId, this.order.subPackOmapiId, this.order.type === Order.DAYPASS);
    this.navigationService.resetNavigation();
    this.pincodeIncorrect = false;
    this.getAndSetSuspentionInformation();
    this.changeDetector.detectChanges();
  }


  pinReceived(event) {
    this.pincodeIncorrect = false;
    if (event && !isNaN(event.pin)) {
      this.pincode = this.pincode + event.pin;
      this.navigationService.navigate(KeyDirections.ARROW_RIGHT);
    }

    if (this.pincode.length === 4) {
      this.checkPincode();
    }
  }

  pinRemoved() {
    this.pincode = this.pincode.slice(0, -1);
  }

  toggleHint() {
    this.showHint = !this.showHint;
  }

  public onEmitOrderSucceeded(): void {
    this.emitOrderSucceeded.emit({
      omapiId: this.order.packOmapiId
    });
  }

  public onEmitOrderFailed(error: Error): void {
    this.emitOrderFailed.emit({
      omapiId: this.order.subPackOmapiId,
      error: error
    });
  }

  public onEmitOrderTimeOut(): void {
    this.emitOrderTimeOut.emit({
      omapiId: this.order.packOmapiId
    });
  }

  public onEmitOpenConditions(): void {
    this.emitOpenConditions.emit({
      omapiId: this.order.packOmapiId
    });
  }

  private checkPincode(): void {
    this.pincodeService.verifyPin(this.pincode)
      .pipe(takeUntil(this.stopSubscription)).subscribe(correctPin => {
      if (correctPin) {
        this.correctPin();
      } else {
        this.incorrectPin();
      }
    });
    this.analyticsService.onProductOrdered(this.order);
  }

  private incorrectPin() {
    this.pincodeIncorrect = true;
    this.pincode = '';
    this.navigationService.resetPage();
    this.getAndSetSuspentionInformation();
  }

  private correctPin() {
    this.pincodeIncorrect = false;
    this.activationPending = true;
    this.stateService.setIsOrderProcessPending(true);
    let activatePackObservable;

    if (this.stateService.selectSnapshot(state => state.isStreamingBundleOrder) || this.stateService.selectSnapshot(state => state.isStreamingServiceOrder)) {
      activatePackObservable = this.stateService.activateStreamingService();
    } else {
      if (OmapiIdsUtils.currentUserType === UserTypeConstants.LEGACY_USER) {
        activatePackObservable = this.ocapiAsynchronousService.activatePack(this.order);
      } else if (OmapiIdsUtils.currentUserType === UserTypeConstants.DWN_USER) {
        activatePackObservable = this.ocapiSynchronousService.activatePack(this.order);
      }
    }

    const activatePack = activatePackObservable
      .pipe(takeUntil(this.stopSubscription))
      .subscribe(
        response => {
          this.clearCache(CacheConstants.DTV_CATALOG);
          if (response.success) {
            this.onEmitOrderSucceeded();
            this.analyticsService.onOrderSucces(this.order);
            this.stopSubscription.next(true);
            this.stateService.setIsOrderProcessPending(false);
          } else {
            this.stateService.setIsOrderProcessPending(false);
            console.log('ERROR for action: ' + response.id + ', activating entertainment pack: ' + response.errorCode + ': ' + response.errorMessage);
            const error = new Error(response.errorCode, response.errorMessage);
            this.onEmitOrderFailed(error);
          }
          this.timeOut = false;
          this.activationPending = false;
        },
        err => {
          this.stateService.setIsOrderProcessPending(false);
          console.log('ERROR for action: ' + err.id + ', activating entertainment pack: ' + err.errorCode + ': ' + err.errorMessage);
          const error = new Error(err.errorCode, err.errorMessage);
          this.onEmitOrderFailed(error);
        });

    this.activateTimeOut(activatePack);
  }

  private activateTimeOut(activateContentPack) {
    setTimeout(() => {
      if (!this.timeOut) {
        this.activationPending = false;
        activateContentPack.unsubscribe();
        this.onEmitOrderTimeOut();
        this.clearCache(CacheConstants.DTV_CATALOG);
      }
    }, TvshopConstants.MAXIMUM_ORDERING_COOL_DOWN_IN_MS);
  }

  private getAndSetSuspentionInformation() {
    this.pincodeService.getRemainingAttempts().subscribe(numberOfTimeLeft => {
      this.numberOfTimeLeft = numberOfTimeLeft;
      if (numberOfTimeLeft <= 0) {
        this.pincodeService.getSuspensionExpiration().subscribe(value => {
          this.suspensionExpiration = value;
          this.suspension = true;
          this.navigationService.navigate(KeyDirections.ARROW_DOWN);
        });
      } else {
        this.suspension = false;
      }
    });
  }

  public onBack(): void {
    (document.activeElement as HTMLElement).blur();
    this.emitOnBack.emit({
      value: true
    });
  }

  private clearCache(cacheConstants: CacheConstants): void {
    if (this.cacheService.has(cacheConstants.toString())) {
      this.cacheService.remove(cacheConstants.toString());
    }
  }

  getPackageName() {
    return this.order.packOmapiId === OmapiIdConstants.RED_CARPET_MORE ? OmapiIdConstants.COM_NAME_RED_CARPET_MORE : this.order.orderName();
  }
}
